import { render } from "./long-arrow.vue?vue&type=template&id=e300c724"
import script from "./long-arrow.vue?vue&type=script&lang=js"
export * from "./long-arrow.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__